/**
 * True when the value has non-whitespace content.
 * Pure helper — no React/Redux.
 */
export const hasFieldValue = (value) => {
  if (value === null || value === undefined) {
    return false;
  }

  return String(value).trim().length > 0;
};

/**
 * Validates a billing address for invoice generation.
 *
 * `vatRequired` mirrors `caseInfo.vat_id_required`.
 * Returns `true` when the address is complete enough to generate an invoice.
 */
export const validateBillingAddress = (
  address,
  { vatRequired = false } = {},
) => {
  const billingAddress = address || {};

  const requiredCustomFieldsValid = (billingAddress.custom_fields || [])
    .filter((field) => field?.required)
    .every((field) => hasFieldValue(field?.value));

  const requiredBillingFieldsValid =
    hasFieldValue(billingAddress.email) &&
    hasFieldValue(billingAddress.name) &&
    hasFieldValue(billingAddress.address_line_1) &&
    hasFieldValue(billingAddress.postal_code) &&
    hasFieldValue(billingAddress.city) &&
    hasFieldValue(billingAddress.country);

  const vatFieldValid = !vatRequired || hasFieldValue(billingAddress.vat_id);

  return (
    vatFieldValid && requiredBillingFieldsValid && requiredCustomFieldsValid
  );
};
